module.exports = __webpack_public_path__ + "img/small-leaf.46d528e8.png";